import { render, staticRenderFns } from "./JSearchSelectTag.vue?vue&type=template&id=27e1bd65&scoped=true&"
import script from "./JSearchSelectTag.vue?vue&type=script&lang=js&"
export * from "./JSearchSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1bd65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e1bd65')) {
      api.createRecord('27e1bd65', component.options)
    } else {
      api.reload('27e1bd65', component.options)
    }
    module.hot.accept("./JSearchSelectTag.vue?vue&type=template&id=27e1bd65&scoped=true&", function () {
      api.rerender('27e1bd65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dict/JSearchSelectTag.vue"
export default component.exports